
// region JS Imports

// region External Modules
import Promise from "plugins/bluebird/index"
// endregion External Modules

// Private Modules
import DataRetriever from "app/data_retriever"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import ActiveSwitches from "./mark-switch-active"
import GoogleMap from "./google_map"
import GoogleStreet from "./google_street"
import Pictures from "./components/pictures"
// endregion Private Components

// endregion JS Imports



const init_with_promise = () => {
  const all_internal_module_init_promises = [] as Array<Promise<void>>

  ActiveSwitches.instance()
  all_internal_module_init_promises.push(Pictures.init_with_promise())
  all_internal_module_init_promises.push(GoogleMap.create_with_promise())

  if (! DataRetriever.get("current-location-country-code-is-china")){
    all_internal_module_init_promises.push(GoogleStreet.create_with_promise())
  }

  return Promise.all(all_internal_module_init_promises)
}

export default {
  init_with_promise,
}
